import { RootState } from '../../store';

export const selectCurrentUser = (state: RootState) => state.auth.userDetails;
export const selectCurrentUserFullName = (state: RootState) =>
  `${state.auth?.userDetails?.firstName} ${state.auth?.userDetails?.lastName}`;
export const selectCurrentUserEmail = (state: RootState) =>
  state.auth?.userDetails?.email;
export const selectIsUserLoginCompleted = (state: RootState) =>
  state.auth.isUserLoginCompleted;
export const selectCurrentAccessToken = (state: RootState) =>
  state.auth.accessToken;
export const selectCurrentIDToken = (state: RootState) => state.auth.idToken;
export const selectCognitoUsername = (state: RootState) =>
  state.auth.cognitoUsername;
export const selectCognitoEmailAddress = (state: RootState) =>
  state.auth.cognitoEmailAddress;
export const selectIsAuthCodeRequired = (state: RootState) =>
  state.auth.isAuthCodeRequired;
export const selectIsSendAuthCodeInProgress = (state: RootState) =>
  state.auth.sendAuthCodeInProgress;
export const selectIsSubmitAuthCodeInProgress = (state: RootState) =>
  state.auth.submitAuthCodeInProgress;
export const selectWorkStarted = (state: RootState) => state.auth.isWorkStarted;
export const selectWorkSuccess = (state: RootState) => state.auth.isWorkSuccess;
export const selectWorkFailed = (state: RootState) => state.auth.isWorkFailure;
export const selectWorkErrorMessage = (state: RootState) =>
  state.auth.workErrorMsg;
export const selectWorkProgressMessage = (state: RootState) =>
  state.auth.workProgressMsg;
export const selectCreateAccountEmailAddress = (state: RootState) =>
  state.auth.createAccountEmailAddress;
export const selectIsAccountCreationCompleted = (state: RootState) =>
  state.auth.isAccountCreationCompleted;
export const selectIsAuthInProgress = (state: RootState) =>
  (!!state.auth.cognitoEmailAddress ||
    !!state.auth.createAccountEmailAddress) &&
  !state.auth.isUserLoginCompleted &&
  !state.auth.isAccountCreationCompleted;
